// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert {
  border: 1px solid;
  border-radius: var(--r-data);
  padding: 10px 12px;
  font-size: var(--fs-ui);
  line-height: 1.45;
  color: var(--text);
}

.alert__title {
  font-weight: 600;
  margin-bottom: 2px;
}

.alert--info {
  background: var(--info-bg);
  border-color: var(--info);
}
.alert--success {
  background: var(--ok-bg);
  border-color: var(--ok);
}
.alert--warning {
  background: var(--warn-bg);
  border-color: var(--warn);
}
.alert--error {
  background: var(--err-bg);
  border-color: var(--danger);
}

/* Dark mode: the status -bg tokens stay light (they have no dark variant), so
   use the elevated surface as the fill and keep the coloured border + light
   text. Readable in both modes without a full dark status palette. */
[data-theme='dark'] .alert {
  background: var(--bg-alt);
}
`, "",{"version":3,"sources":["webpack://./src/ui/Alert/Alert.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;qEAEqE;AACrE;EACE,yBAAyB;AAC3B","sourcesContent":[".alert {\n  border: 1px solid;\n  border-radius: var(--r-data);\n  padding: 10px 12px;\n  font-size: var(--fs-ui);\n  line-height: 1.45;\n  color: var(--text);\n}\n\n.alert__title {\n  font-weight: 600;\n  margin-bottom: 2px;\n}\n\n.alert--info {\n  background: var(--info-bg);\n  border-color: var(--info);\n}\n.alert--success {\n  background: var(--ok-bg);\n  border-color: var(--ok);\n}\n.alert--warning {\n  background: var(--warn-bg);\n  border-color: var(--warn);\n}\n.alert--error {\n  background: var(--err-bg);\n  border-color: var(--danger);\n}\n\n/* Dark mode: the status -bg tokens stay light (they have no dark variant), so\n   use the elevated surface as the fill and keep the coloured border + light\n   text. Readable in both modes without a full dark status palette. */\n[data-theme='dark'] .alert {\n  background: var(--bg-alt);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
